module.exports = __webpack_public_path__ + "media/images/items/eyecatch-profile-book-c39d20d81224080b52aa7d42935645b5.png";